"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var analytics_1 = require("utils/analytics");
var backend_1 = require("utils/backend");
var chargebee_1 = require("utils/chargebee");
var HoCs_1 = require("utils/HoCs");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var PlanBox_1 = __importDefault(require("../styles/PlanBox"));
var PlanCard_1 = __importDefault(require("../styles/PlanCard"));
var PlanFeatures_1 = __importDefault(require("../styles/PlanFeatures"));
var PlanLayout_1 = __importDefault(require("../styles/PlanLayout"));
var PlanSettings = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _a = __read((0, hooks_1.useSubmitter)('companies', profile.companyId), 1), companySubmitter = _a[0];
    var _b = __read((0, react_1.useState)('Annual'), 2), planFrequency = _b[0], setPlanFrequency = _b[1];
    var _c = __read((0, chargebee_1.useOpenCheckout)(), 1), openCheckout = _c[0];
    var _d = __read((0, chargebee_1.useFetchSubscriptionForCompany)(), 1), fetchSubscription = _d[0];
    (0, react_1.useEffect)(function () {
        fetchSubscription()();
    }, []);
    var handleNonChargebeeUser = function (plan) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(plan === 'Start-Up')) return [3 /*break*/, 2];
                    return [4 /*yield*/, companySubmitter({ plan: 'Start-Up', planStatus: 'active' })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
                case 2: return [4 /*yield*/, openCheckout(plan, planFrequency)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleChargebeeUser = function (planName) { return __awaiter(void 0, void 0, void 0, function () {
        var cbInstance;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, chargebee_1.getCbInstanceAsync)()];
                case 1:
                    cbInstance = _a.sent();
                    cbInstance.openCheckout({
                        hostedPage: function () {
                            return __awaiter(this, void 0, void 0, function () {
                                var result, data;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, backend_1.callBackendFn)('payments-generateUpgradeSubscriptionUrl', {
                                                userId: profile === null || profile === void 0 ? void 0 : profile.companyId,
                                                planName: planName,
                                                planFreq: planName === 'Growth' ? planFrequency : 'Monthly',
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            data = result.data;
                                            return [2 /*return*/, data];
                                    }
                                });
                            });
                        },
                        close: function () {
                            fetchSubscription()();
                        },
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var trackBillingPlanChange = (0, analytics_1.usePreparedTracker)('Billing Plan Change');
    var trackBillingFrequency = (0, analytics_1.usePreparedTracker)('Billing Frequency Toggled');
    var handlePlanChange = function (planName, upgradeOrDowngrade) {
        var hasChargebee = company === null || company === void 0 ? void 0 : company.hasChargebee;
        trackBillingPlanChange({
            hasChargebee: hasChargebee,
            planName: planName,
            planFrequency: planFrequency,
            type: upgradeOrDowngrade,
        });
        if (hasChargebee) {
            handleChargebeeUser(planName);
        }
        else {
            handleNonChargebeeUser(planName);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Plan Settings", description: "Billing Settings" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsxs)(PlanLayout_1.default, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ textAlign: "center" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Plans and pricing" })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", mt: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Monthly" })), (0, jsx_runtime_1.jsx)(material_1.Switch, { checked: planFrequency === 'Annual', onChange: function (e) {
                                                var frequency = e.target.checked ? 'Annual' : 'Monthly';
                                                trackBillingFrequency({ planFrequency: frequency });
                                                setPlanFrequency(frequency);
                                            }, name: "planFreq", inputProps: { 'aria-label': 'secondary checkbox' } }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Annual (save 15%)" }))] }))] })), (0, jsx_runtime_1.jsxs)(PlanBox_1.default, { children: [(0, jsx_runtime_1.jsxs)(PlanCard_1.default, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Start-Up ", (company === null || company === void 0 ? void 0 : company.plan) === 'Start-Up' && '(current plan)'] })), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Free" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "forever" })), (0, jsx_runtime_1.jsxs)(PlanFeatures_1.default, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Xero, Quickbooks or CSV Upload" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "SaaS stack management" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Self-serve onboarding" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Basic credits and discounts" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "5 users" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Renewals and alerts" }))] }), (company === null || company === void 0 ? void 0 : company.plan) === 'Start-Up'
                                            ? (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ fullWidth: true, disabled: true }, { children: "Upgrade" }))
                                            : (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ fullWidth: true, onClick: function () { return handlePlanChange('Start-Up', 'Downgrade'); } }, { children: "Downgrade" }))] }), (0, jsx_runtime_1.jsxs)(PlanCard_1.default, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Growth ", (company === null || company === void 0 ? void 0 : company.plan) && company.plan === 'Growth' && planFrequency === company.planFrequency && ' (current plan)'] })), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, align: "inherit" }, { children: planFrequency === 'Annual' ? '$85 USD' : '$100 USD' })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["per month - billed ", planFrequency === 'Annual' ? 'annually' : 'monthly'] })), (0, jsx_runtime_1.jsxs)(PlanFeatures_1.default, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (0, jsx_runtime_1.jsx)("strong", { children: "All start-up features, plus:" }) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Connect multiple accounting systems" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Benchmarking and pricing insights" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Assisted onboarding" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Exclusive SaaS purchasing discounts" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Unlimited users" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "SaaS audit with saving opportunities" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "SaaS forecast and spend predictions" })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Priority support" }))] }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ fullWidth: true, disabled: (company === null || company === void 0 ? void 0 : company.plan) === 'Growth' && planFrequency === company.planFrequency
                                                && company.planStatus !== 'in_trial', onClick: function () { return handlePlanChange('Growth', 'Upgrade'); } }, { children: "Upgrade" }))] })] })] }) })] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(PlanSettings);
